import { render } from "./SearchPaging.vue?vue&type=template&id=450689fe"
import script from "./SearchPaging.vue?vue&type=script&lang=js"
export * from "./SearchPaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__